import { useNetworkDecimal } from '#/data/useNetworks';
import useWatcherPriceList from '#/data/useWatcherPriceList';
import parseUnits from '#/utils/parseUnits';
import { ethers } from 'ethers';
import { useMemo } from 'react';
import Skeleton from './Skeleton';

interface Props {
  symbol?: string;
  value?: string;
}

export default function NetworkUSDValue({ symbol, value }: Props) {
  const decimal = useNetworkDecimal(symbol);
  const { data, isLoading } = useWatcherPriceList();
  const price = useMemo(
    () => data?.data.data?.find(item => item.symbol === symbol)?.price,
    [data]
  );
  const resultAsBigNumber = useMemo(
    () =>
      price && value
        ? ethers.BigNumber.from(value).mul(parseUnits(String(price), 8))
        : null,
    [value, price]
  );
  const resultAsString = useMemo(
    () =>
      decimal != null && resultAsBigNumber
        ? ethers.utils.commify(
            ethers.utils.formatUnits(
              resultAsBigNumber.div(
                ethers.BigNumber.from(10).pow(decimal + 8 - 2)
              ),
              2
            )
          )
        : null,
    [decimal, resultAsBigNumber]
  );
  return (
    <Skeleton isLoading={isLoading || resultAsString == null} className="w-16">
      ${resultAsString}
    </Skeleton>
  );
}
